import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import TransporterDetail from './components/TransporterDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageTransporter',
  components: {
    TransporterDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;